import React, { useEffect, useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toolbar } from 'primereact/toolbar';
import { Panel } from 'primereact/panel';
import { Button } from 'primereact/button';
import { TabView, TabPanel } from 'primereact/tabview';
import { Dialog } from 'primereact/dialog';
import * as generic from '../../../../components/Generico';
import { useLazyParams } from '../../../../hooks/useLazyParams';
import { TablaDinamica } from '../../../../components/TablaDinamica';
import { Column } from 'primereact/column';
import { Menu } from 'primereact/menu';
import { Card } from 'primereact/card';
import { AnexosComponent } from '../../../../components/AnexosComponent';
import { useToken } from '../../../../components/useToken';
import { InfoGeneral } from './InfoGeneral';
import { EmpleadoDirector } from '../../../../models/trust/empleado/EmpleadoDirector';
import { EmpleadoAcDirService } from '../../../../service/trust/empleado/EmpleadoAcDirService';
import { LaboralEconomica } from './LaboralEconomica';
import { InformacionEconomica } from './InformacionEconomica';
import { PatrimonioDetalle } from './PatrimonioDetalle';
import { Declaracion } from './Declaracion';
import { DialogInstrucciones } from '../../../../components/ui/DialogInstrucciones';

export const InfoEmpleado = () => {
    const [catalogos, setCatalogos] = useState(null);
    const omodel = new EmpleadoDirector({ formularioMatriz: catalogos?.formularioMatriz });
    const toast = useRef(null);
    const empleadoServicio = new EmpleadoAcDirService();
    const { getPerss, getRol } = useToken();
    // Estados Globales del Formulario
    const [empleado, setEmpleado] = useState(null);
    const [permss, setPermss] = useState(null);
    // Estados de navegación y UI
    const [dialogEmpleado, setDialogEmpleado] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [siCliente, setSiCliente] = useState(false);
    const [urls, setUrls] = useState(null);
    const [dialogAnexos, setDialogAnexos] = useState(false);
    const tablaEstado = useLazyParams({ modelo: omodel.model });
    const menuRef = useRef(null);
    const topRef = useRef(null);
    const [mostrarRegresarFlotante, setMostrarRegresarFlotante] = useState(false);
    const [dialogInstruccion, setDialogInstruccion] = useState(false);
    const [soloLectura, setSoloLectura] = useState(false);
    const [opcion, setOpcion] = useState(null);

    useEffect(() => {
        setUrls({
            urlListado: 'ficha/trust/empleado-ac-dir',
            urlDownload: 'ficha/trust/empleado-ac-dir/descarga',
            urlUpload: 'ficha/trust/empleado-ac-dir/store',
            udelete: 'ficha/trust/empleado-ac-dir/eliminar-anexo',
            uactual: 'ficha/trust/empleado-ac-dir/editar',
            uenviar: 'ficha/trust/empleado-ac-dir/enviar',
            uaprobar: 'ficha/trust/empleado-ac-dir/aprobar',
        });

        const permisosToken = getPerss();
        const esClienteNotificado = permisosToken !== undefined;
        setSiCliente(esClienteNotificado);
        if (esClienteNotificado) { // FLUJO CLIENTE NOTIFICADO
            // Al tener permisos en el token, se asignan y se le redirige directamente  a su propia ficha enviando ID 0 (el backend resolverá su registro).
            setPermss(permisosToken);
            editFicha(true); // Es un usuario notificado
        }
        // eslint-disable-next-line
    }, []); // Array vacío para que solo se ejecute al montar el componente

    useEffect(() => {
        const esClienteNotificado = getPerss() !== undefined;
        // Solo cargamos la lista si es un usuario interno
        if (!esClienteNotificado) {
            loadLazyData();
        }
        // eslint-disable-next-line
    }, [tablaEstado.lazyParams]);

    // Efecto para observar el inicio del formulario
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setMostrarRegresarFlotante(!entry.isIntersecting);
            },
            { threshold: 0 }
        );
        const currentRef = topRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }
        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [dialogEmpleado]); // Dependencia clave: se re-ejecuta cuando abre/cierra el formulario


    const loadLazyData = () => {
        tablaEstado.setLoading(true);
        let _lazyParams = { ...tablaEstado.lazyParams };
        delete _lazyParams.rtipo;
        if (permss == null) {
            _lazyParams.rtipo = true;
        }
        const rol = getRol();
        if (!rol) {
            toast.current.show({ severity: 'warn', summary: 'Rol no seleccionado', detail: 'Por favor selecciona un rol antes de continuar.', life: 3000 });
            tablaEstado.setLoading(false);
            return;
        } else {
            _lazyParams.rol = rol;
        }
        empleadoServicio.getLista({ lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            tablaEstado.setTotalRecords(res.data.total);
            tablaEstado.setData(res.data.registros);
            if (res.data.perss !== undefined) {
                setPermss(res.data.perss);
                setOpcion(res.data.opcion);
            }
            if (res.data.cats) {
                setCatalogos(res.data.cats);
            }
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    }

    const iniciarNuevo = () => { // Los catalogos ya existen puesto que se cargan en el index para usuarios internos
        setSoloLectura(false);
        setDialogEmpleado(true);
        setEmpleado(null); // Limpiamos el actual
        setActiveIndex(0);
        setDialogInstruccion(true);
    }

    const editFicha = (esNotificado = false, isReadOnly = false) => {
        setSoloLectura(isReadOnly);
        const idConsulta = esNotificado ? 0 : empleado?.id;
        const necesitaCatalogos = catalogos === null;
        //console.log(empleado?.id, esNotificado, idConsulta);
        empleadoServicio.consultar(idConsulta, { necesitaCatalogos: necesitaCatalogos }).then(res => {
            if (necesitaCatalogos && res.data.catalogos) {
                setCatalogos(res.data.catalogos);
            }
            if (!res.data.empleado) {
                iniciarNuevo();
                return;
            }
            setDialogEmpleado(true);
            setActiveIndex(0);
            setDialogInstruccion(true);
            // Sincronizamos el estado principal con lo que necesitamos para navegar
            nuevoEmpleado({
                id: res.data.empleado.id,
                nemonico: res.data.empleado.nemonico,
            });
        }).finally(() => {

        });
    }

    const confirmDelete = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar el formulario?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => deleteEmpleado()
        });
    }

    const deleteEmpleado = () => {
        empleadoServicio.eliminar(empleado.id).then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    // FUNCIÓN VITAL PARA MANTENER SINCRONIZADAS LAS TABS
    const nuevoEmpleado = (nuevo) => {
        // Si se envía null, limpiamos el estado por completo.
        if (!nuevo) {
            setEmpleado(null);
            return;
        }
        // Usamos el callback (prev => ...) propio de React.
        // Con el spread operator (...prev, ...nuevo):
        // - Mantemos la base limpia que inyectó la tabla (rowData).
        // - Agregamos o actualizamos SOLO lo que necesitamos (ej. nemonico)
        setEmpleado(prev => ({ ...prev, ...nuevo }));
    }

    const handleNext = () => { if (activeIndex < 4) setActiveIndex(activeIndex + 1); };
    const handlePrev = () => { if (activeIndex > 0) setActiveIndex(activeIndex - 1); };

    const regresar = () => {
        setActiveIndex(0);
        setDialogEmpleado(false);
        setSoloLectura(false);
        if (!siCliente) loadLazyData();
    }

    const reiniciar = () => {
        if (!siCliente) loadLazyData();
        setDialogEmpleado(false);
        setDialogAnexos(false);
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.consultar) {
            items.push({ label: 'Ver', icon: 'pi pi-eye', command: () => { editFicha(false, true); } });
        }
        if (permss?.actualizar && (empleado?.nemonico === 'BORRADOR' || empleado?.nemonico === 'ENVIADO')) {
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editFicha() } });
        }
        if (permss?.consultar) items.push({ label: 'Anexos formulario', icon: 'pi pi-folder-open', command: () => { setDialogAnexos(true) } });
        if (permss?.eliminar && empleado?.nemonico === 'BORRADOR') {
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });
        }
        return [{ label: 'Opciones', items: items }];
    }

    const accionesTemplate = (rowData) => {
        return (
            <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu" aria-haspopup
                onClick={(event) => { setEmpleado(rowData); menuRef.current.toggle(event); }} />
        );
    };

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '6rem', textAlign: 'center' }} />
    );

    const panelHeaderTemplate = (options) => (
        <div className="p-panel-header flex justify-content-between align-items-center flex-wrap gap-2 w-full">
            <div>
                <h3 className="m-0 text-xl font-bold p-text-secondary flex align-items-center">
                    <i className="pi pi-folder-open mr-2"></i>
                    <span className="mr-2">{empleado?.id ? 'EDITAR' : 'NUEVO'} FORMULARIO DE INFORMACIÓN DEL EMPLEADO / DIRECTOR</span>
                    <Button type="button" icon="pi pi-question-circle" className="p-button-rounded p-button-text p-button-sm p-0 m-0 text-white hover:text-blue-200 transition-colors transition-duration-200"
                        style={{ width: '2rem', height: '2rem' }} onClick={() => setDialogInstruccion(true)} tooltip="Ver instrucciones" tooltipOptions={{ position: 'right' }} />
                </h3>
            </div>
            {!siCliente && (
                <Button tooltip="Regresar al listado" tooltipOptions={{ position: 'left' }} icon="pi pi-arrow-left" onClick={regresar} />
            )}
        </div>
    );

    return (
        <>
            <ConfirmDialog className="dialog-personalizado" />
            <Toast ref={toast} />
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu" />
            {!dialogEmpleado && !siCliente && (
                <div className="fadein animation-duration-300">
                    <Toolbar className="mb-4 shadow-1 border-round" start={generic.leftToolbarTemplate(iniciarNuevo, '', permss)} end={generic.rightToolbarTemplate(tablaEstado.data, omodel, 'Listado_empleado', 'LISTADO INFORMACIÓN EMPLEADO')} />
                    <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                        <TablaDinamica modelo={omodel.model} estadoTabla={tablaEstado} datos={tablaEstado.data} totalRegistros={tablaEstado.totalRecords} dataKey="id" acciones={ColumnaAcciones} />
                    </Card>
                </div>
            )}
            {dialogEmpleado &&
                <div className="fadein animation-duration-300">
                    <Panel headerTemplate={panelHeaderTemplate} className="panel-ficha shadow-2">
                        <div ref={topRef} style={{ position: 'absolute', top: '0', left: '0', width: '1px', height: '80px', pointerEvents: 'none', visibility: 'hidden' }} />
                        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="form-tabview">
                            <TabPanel header="Sección 1" leftIcon="pi pi-id-card mr-2" disabled={empleado == null}>
                                <InfoGeneral toast={toast} id={empleado?.id} empleado={empleado}
                                    permss={permss} catalogos={catalogos} handleNext={handleNext}
                                    nuevoEmpleado={nuevoEmpleado} soloLectura={soloLectura} />
                            </TabPanel>

                            <TabPanel header="Sección 2" leftIcon="pi pi-briefcase mr-2" disabled={!empleado?.id}>
                                <LaboralEconomica handlePrev={handlePrev} handleNext={handleNext}
                                    toast={toast} id={empleado?.id} permss={permss} catalogos={catalogos}
                                    soloLectura={soloLectura} />
                            </TabPanel>

                            <TabPanel header="Sección 3" leftIcon="pi pi-briefcase mr-2" disabled={!empleado?.id}>
                                <InformacionEconomica handlePrev={handlePrev} handleNext={handleNext}
                                    toast={toast} id={empleado?.id} permss={permss} catalogos={catalogos}
                                    soloLectura={soloLectura} />
                            </TabPanel>

                            <TabPanel header="Sección 4" leftIcon="pi pi-briefcase mr-2" disabled={!empleado?.id}>
                                <PatrimonioDetalle handlePrev={handlePrev} handleNext={handleNext}
                                    toast={toast} id={empleado?.id} permss={permss} catalogos={catalogos}
                                    nuevoEmpleado={nuevoEmpleado} soloLectura={soloLectura} />
                            </TabPanel>

                            <TabPanel header="Sección 5" leftIcon="pi pi-briefcase mr-2" disabled={!empleado?.id}>
                                <Declaracion handlePrev={handlePrev} toast={toast} id={empleado?.id} permss={permss} nuevoEmpleado={nuevoEmpleado}
                                    setDialogAnexos={setDialogAnexos} soloLectura={soloLectura} />
                            </TabPanel>

                        </TabView>
                    </Panel>

                    {mostrarRegresarFlotante && !siCliente && (
                        <div className="fadein scalein" style={{ position: 'fixed', top: '65px', right: '30px', zIndex: 999 }}>
                            <Button icon="pi pi-arrow-left" onClick={regresar} rounded className="p-button-primary shadow-4" style={{ width: '45px', height: '45px' }} tooltip="Regresar al listado" tooltipOptions={{ position: 'left' }} />
                        </div>
                    )}
                </div>
            }

            <DialogInstrucciones visible={dialogInstruccion} onHide={() => setDialogInstruccion(false)} title={omodel.titulo} items={omodel.pasosInstrucciones} />
            <Dialog visible={dialogAnexos} header="Gestión de Anexos" modal className="p-fluid modal-ssize dialog-personalizado" onHide={() => setDialogAnexos(false)} style={{ width: '800px' }}>
                <AnexosComponent tipo="empleadoAcDirTf" urls={urls} idp={empleado?.id} toast={toast} permss={permss} 
                    setDialogSubir={setDialogAnexos} reiniciar={reiniciar} estado={empleado?.nemonico} soloLectura={soloLectura} opcion={opcion} />
            </Dialog>
        </>
    )
}